import {
    Vue, Component, Prop,
} from 'vue-property-decorator';

/**
 * Loading Props
 */
@Component
class Props extends Vue {
    /**
     * Type
     */
    @Prop() type!: string;

    /**
     * Size
     */
    @Prop({ default: 24, type: [Number, String] }) size!: number | string;

    /**
     * text
     */
    @Prop() text!: undefined;

    /**
     * Height
     */
    @Prop() height!: number | string;

    /**
     * Position state
     */
    @Prop({ default: 'fixed' }) position!: string;

    /**
     * Active status
     */
    @Prop({ type: Boolean }) active!: boolean;

    /**
     * Background of the Loading
     */
    @Prop() background!: string

    /**
     * Color of the Loading
     */
    @Prop() color!: string
}

export default Props;
